/* global swal angular */
import './style.less';

export default function($uibModalInstance, $log, ApiClass, ProfileClass, location) {
  'ngInject';
  try {
    const { company_id } = ProfileClass.profileComplete.profile;

    const vm = this;

    vm.close = item => $uibModalInstance.close(item || 'cancel');

    vm.formData = angular.copy(location);

    vm.update = function() {
      vm.locationUpdateBtn = true;
      ApiClass.companiesIdTypeTypeIdPatch(
        { manage: true, id: company_id, type: 'locations', type_id: vm.formData.location_id },
        vm.formData
      )
        .then(({ data: { item } }) => {
          vm.locationUpdateBtn = false;
          vm.close(item);
        })
        .catch(error => {
          swal('Error', 'Please review and submit again', 'warning');
          vm.locationUpdateBtn = false;
          $log.error(error);
          throw error;
        });
    };
  } catch (error) {
    $log.error(error);
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/editLocation/index.js